import React  from "react";
import LoginPage from "../components/LoginPage.tsx"
import SessionService from "../api_handlers/services/SessionService.ts"
import IInitializeSessionVM from '../api_handlers/view_modals/IInitializeSessionVM.ts'
import { useAppDispatch, } from '../redux/hook.ts';
import { setSession } from "../redux/sessionSlice.ts";
import { setUser } from "../redux/userSlice.ts";
import { useToast } from '../components/base_components/ToastContext.tsx';
import { useNavigate } from "react-router-dom";

const VotinSessionLogin = () => {
    const dispatch = useAppDispatch();
    const { showToast } = useToast();
    const navigate = useNavigate();
    return (
        <LoginPage onLoginClickCallback={async (_data) => {
            var gaminarCode = _data.gaminarCode;
            const vm: IInitializeSessionVM = {
                userEmail: _data.email,
                userName: _data.name,
                teamId: _data.teams,
                gaminarCode: _data.gaminarCode,
            };
            SessionService.initializeVotingSession(vm).then((data) => {
                var sessionId = data.data.sessionId;
                var teamId = data.data.teamId;
                var userId = data.data.userId;
                console.log(sessionId);
                dispatch(setSession({ sessionId: sessionId, teamId: teamId, userId: userId, gaminarCode: gaminarCode }));
                console.log(_data);
                dispatch(setUser({email: _data.email, userName: _data.name}))
                navigate('/LandingPage');
            }).catch((err) => {
                if (err.status === 500 && err.response.data) {
                    showToast(err.response.data, "error");
                }
            });
        }}  headerText="Login to Voting Session"></LoginPage>
    )
}

export default VotinSessionLogin;